/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    confirmResetButton: {
        innerHTML: "Reset"
    },
    forgottenPasswordTitle: {
        innerText: "Forgotten Password"
    }
};